import Vue from 'vue'
import App from './App.vue'
import router from './router'
import dayjs from 'dayjs'
import './plugins/element.js'
import './global.less'

import "./assets/js/openseadragon"
import "./assets/js/openseadragon-paperjs-overlay"
import Paper from "../node_modules/paper/dist/paper-full.js"
window.paper = Paper.paper

Vue.config.productionTip = false
Vue.prototype.$dayjs = dayjs
window.log = console.log
console.log(`当前运行环境: ${process.env.NODE_ENV}`)
const whitePath = ['/desktop/foot-page']
if (!whitePath.includes(location.pathname)) {
  if (!localStorage.getItem('user')) {
    location.href = `/account/login`
  } else if (!document.cookie.includes('user_login_token')) {
    location.href = `/account/login`
  }
}
console.log(`update in ${process.env.VUE_APP_TIME}`)
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
